import React from 'react'
import PropTypes from 'prop-types'
import Button from '#components/a/Button'
import ControlsGroup from '#components/m/ControlsGroup'
import {LoadingButton} from '../LoadingButton'

class DialogControlButtons extends React.Component {
  render() {
    return (
      <ControlsGroup>
        <Button type="reset" text="Abbrechen" variant="secondarydark" event={this.props.onCloseClick} />
        <LoadingButton
          type="submit"
          text="Speichern"
          variant="primarydark"
          event={this.props.onSubmitClick}
          disabled={this.props.disableSubmit}
          disabledReason={this.props.disabledSubmitReason}
          isLoading={this.props.isLoading}
        />
      </ControlsGroup>
    )
  }
}

DialogControlButtons.propTypes = {
  onCloseClick: PropTypes.func,
  onSubmitClick: PropTypes.func,
  disableSubmit: PropTypes.bool,
  disabledSubmitReason: PropTypes.string,
  isLoading: PropTypes.bool,
}

export default DialogControlButtons
